import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

export default function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="border-2 border-foreground bg-white px-6 py-4 shadow-brutal animate-pulse" data-testid="protected-loading">
          <p className="font-bold uppercase tracking-wider text-sm">Memuat...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
